import { render, staticRenderFns } from "./exchangeOrder.vue?vue&type=template&id=276e5cf8&scoped=true&"
import script from "./exchangeOrder.vue?vue&type=script&lang=js&"
export * from "./exchangeOrder.vue?vue&type=script&lang=js&"
import style0 from "./exchangeOrder.vue?vue&type=style&index=0&id=276e5cf8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "276e5cf8",
  null
  
)

export default component.exports